<template>
  <div>
    <h1 class="grandTitre text-center pt-5">{{ msgRedirection }}</h1>
  </div>
</template>

<script>
import { getCurrentLanguage, inMgnl } from '@/helpers/AppHelpers';

export default {
  name: 'RedirectionLangue',
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  data() {
    return {
      msgRedirection: 'Redirection en cours...',
    };
  },
  mounted() {
    if (!inMgnl) {
      const currentLanguage = getCurrentLanguage();
      const destinationLanguage = this.getLocale();
      const lienInterneRedirection = this.jel_nettoyerLienInterne(this.content.lienInterne);

      const lienRedirection = `${this.$store.getters['routes/getUrlFromWebsitePath'](
        lienInterneRedirection
      )}`;

      if (destinationLanguage === 'en') {
        this.msgRedirection = 'Redirecting...';
      }

      if (destinationLanguage === currentLanguage) {
        // redirection dans la langue courante
        window.location.href = `${window.location.origin}/${destinationLanguage}${lienRedirection}`;
      } else {
        // redirect dans l'autre langue
        const lienRedirectionAutreLangue =
          this.$store.getters['routes/getPathAutreLangue'](lienRedirection);

        window.location.href = `${window.location.origin}/${destinationLanguage}${lienRedirectionAutreLangue}`;
      }
    } else {
      console.log('Dans Mangolia: Aucune redirection...');
    }
  },
  methods: {
    getLocale() {
      // Méthode getLocale plutôt qu'utiliser celle du i18n sinon elle retourne une valeur basée sur le url (ex : /fr)
      // Regarde si un cookie est défini
      const cookieLocale = this.getCookieValue('cust_xl');
      if (cookieLocale) {
        // TODO: La valeur du cookie sera surement à manipuler
        return cookieLocale;
      }
      // Sinon retourner la valeur par défaut du navigateur
      const browserLanguage = this.getBrowserLanguage();
      if (browserLanguage == 'en' || browserLanguage == 'fr') {
        return browserLanguage;
      }
      // Si aucun language n'est trouvé
      const locale = document.querySelector('html').getAttribute('lang') === 'en' ? 'en' : 'fr';
      return locale;
    },

    getCookieValue(cookieName) {
      const cookies = document.cookie;
      if (cookies) {
        const cookiesParsed = cookies.split('; ');
        const cookie = cookiesParsed.find((el) => {
          return el.startsWith(`${cookieName.toLowerCase()}=`);
        });
        if (cookie) {
          return cookie.split('=')[1];
        }
      }
      return null;
    },

    getBrowserLanguage() {
      let lang = window.navigator.language;
      if (lang.includes('-')) {
        lang = lang.substr(0, lang.indexOf('-'));
      }

      return lang;
    },
  },
};
</script>
